const PREFIX = 'app_'

export const saveToStorage = <T>(key: string, value: T): void => {
  try {
    const serialized = JSON.stringify(value)
    localStorage.setItem(PREFIX + key, serialized)
  } catch (error) {
    console.error(`Error saving to localStorage [${key}]:`, error)
  }
}

export const getFromStorage = <T>(key: string): T | null => {
  try {
    const item = localStorage.getItem(PREFIX + key)
    return item ? JSON.parse(item) : null
  } catch (error) {
    console.error(`Error reading from localStorage [${key}]:`, error)
    return null
  }
}

export const removeFromStorage = (key: string): void => {
  try {
    localStorage.removeItem(PREFIX + key)
  } catch (error) {
    console.error(`Error removing from localStorage [${key}]:`, error)
  }
}

export const clearStorage = (): void => {
  try {
    Object.keys(localStorage).forEach(key => {
      if (key.startsWith(PREFIX)) {
        localStorage.removeItem(key)
      }
    })
  } catch (error) {
    console.error('Error clearing storage:', error)
  }
}